export default __webpack_public_path__ + "static/media/FMOS.1689f40c.png";